export const deepCloneRoom = (rooms: TRoom[]) => {
  return rooms.map((room) => ({
    ...room,
    children: (room.children ?? []).map((child) =>
      child
        ? { ...child, age: child.age ? { ...child.age } : undefined }
        : undefined,
    ),
  }));
};

export const CONFIG_SEARCH_AVAILABLE_ROOM = {
  MAXIMUM_ADULTS_LIMIT: 15,
  MAXIMUM_CHILDREN_LIMIT: 7,
  MAXIMUM_ROOMS_LIMIT: 9,
};

export type TRoom = {
  adults: number;
  children: (
    | {
        age?: {
          label: string;
          value: number;
        };
        isBed?: boolean;
      }
    | undefined
  )[];
  id?: string | number;
};

export type TChildren =
  | {
      age?: {
        value: number;
        label: string;
      };
      isBed?: boolean;
    }
  | undefined;

import {
  mapToRequestObject,
  SearchAvailableRoom,
} from "./SearchAvailableRoomMobile";

export const createBookingParams = (
  values: SearchAvailableRoom,
  additionalParams: Record<
    string,
    string | number | boolean | undefined | null | object
  > = {},
): ReturnType<typeof mapToRequestObject> &
  Record<string, string | number | boolean | undefined | null | object> => {
  const mappedData = mapToRequestObject(values);

  return {
    ...mappedData,
    ...additionalParams,
  };
};
